import React from 'react';
import { string, object, bool } from 'prop-types';
import styled from 'styled-components';
import ProductsTitle from '../../../products/products-title/ProductsTitle';
import Balance from '../../components/balance/BalanceWrapperContainer';

const Container = styled.aside`
  padding: 10px 0 15px;
  position: relative;
  text-align: center;

  @media(min-width: 1000px) {
    padding: 25px 0;
    margin: 0;
  }
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const SellFast = styled.p`
  border-top: 1px solid #e5e5e5;
  padding-top: 16px;
  line-height: 1.5;
  color: #4a4a4a;
  margin: 0 10px;

  @media(min-width: 1000px) {
    border-top: 1px solid #e5e5e5;
    padding-top: 16px;
    margin-top: 32px;
    color: #4a4a4a;
    line-height: 1.31;
  }
`;

const FreeHeader = ({
  content, type, limits, adName, purchased,
}) => (
  <Container>
    <Section>
      <ProductsTitle title={content.title} type={type} />
      <Balance balance={limits.balance.value} text={content.balance} show={limits.balance.show} />
    </Section>
    <SellFast>
      {
        purchased ?
          content.productAlreadyBoughtMessage :
          `Quer vender mais rápido? Destaque seu anúncio "${adName}"`
      }
    </SellFast>
  </Container>
);

FreeHeader.propTypes = {
  content: object.isRequired,
  type: string.isRequired,
  limits: object,
  adName: string.isRequired,
  purchased: bool,
};

FreeHeader.defaultProps = {
  limits: { show: false, value: false },
  purchased: false,
};

export default FreeHeader;
